const DEFAULT_ENTERED_CLASS = 'height-expand-panel--entered'

export function useHeightExpandTransition(enteredClass = DEFAULT_ENTERED_CLASS) {
    function beforeEnter(el: Element) {
        const node = el as HTMLElement
        node.classList.remove(enteredClass)
        node.style.height = '0'
    }

    function enter(el: Element) {
        ;(el as HTMLElement).style.height = `${(el as HTMLElement).scrollHeight}px`
    }

    function afterEnter(el: Element) {
        const node = el as HTMLElement
        node.style.height = ''
        node.classList.add(enteredClass)
    }

    function beforeLeave(el: Element) {
        const node = el as HTMLElement
        node.classList.remove(enteredClass)
        node.style.height = `${node.scrollHeight}px`
    }

    function leave(el: Element) {
        ;(el as HTMLElement).style.height = '0'
    }

    function afterLeave(el: Element) {
        ;(el as HTMLElement).style.height = ''
    }

    return {
        beforeEnter,
        enter,
        afterEnter,
        beforeLeave,
        leave,
        afterLeave,
        enteredClass,
    }
}
